export default "__VITE_ASSET__f$cIXbrt__"